import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/AppLogin/Login/Login";
import Main_Menu from "@/components/AppLms/Menu/Main_Menu";

const restorePass = () =>
  import("@/components/AppLogin/Login/RestablecerUsuario");

const Dashboard = () => import("@/components/AppLms/Dashboard/Dashboard");

const AccionPrueba = () => import("@/components/AppLms/Plan_Capacitacion/Consultar_Plan_Capacitacion/acciones/accionPrueba");


//Catalogos/Empleados
const Empleados = () =>
  import("@/components/AppLms/Catalogos/Empleados/Empleados");

//Catalogos/Asignacion
const Cambiar_Perfil_Usuario = () =>
  import(
    "@/components/AppLms/Catalogos/Asignacion/Cambiar_Perfil_Usuario/Cambiar_Perfil_Usuario"
  );
const Analista_Simulado = () =>
  import(
    "@/components/AppLms/Catalogos/Asignacion/Analista_Simulado/Analista_Simulado"
  );

//Catalogos/Control de Poblacion
const Control_Poblacion = () =>
  import("@/components/AppLms/Catalogos/Control_Poblacion/Control_Poblacion");

//Catalogos/Datos STPS
const areas_tematicas = () =>
  import(
    "@/components/AppLms/Catalogos/Datos_STPS/Areas_Tematicas/Areas_Tematicas"
  );
const Representantes_DC3 = () =>
  import(
    "@/components/AppLms/Catalogos/Datos_STPS/Representantes_DC3/Representantes_DC3"
  );
const Plantilla_DC4 = () =>
  import(
    "@/components/AppLms/Catalogos/Datos_STPS/Plantilla_DC4/Plantilla_DC4"
  );
const Establecimientos_STPS = () =>
  import(
    "@/components/AppLms/Catalogos/Datos_STPS/Establecimientos_STPS/Establecimientos_STPS"
  );

//Catalogos/Recursos Capacitacion
const Recursos_Capacitacion = () =>
  import(
    "@/components/AppLms/Catalogos/Recursos_Capacitacion/Recursos_Capacitacion"
  );
//Catalogos/Temas
const Crear_Tema = () =>
  import("@/components/AppLms/Catalogos/Temas/Crear_Tema/Crear_Tema");
const Ver_Tema = () =>
  import("@/components/AppLms/Catalogos/Temas/Crear_Tema/Crear_Tema");
const Preguntas_Tema = () =>
  import("@/components/AppLms/Catalogos/Temas/Preguntas_Tema/Preguntas_Tema");
const Listar_Temas = () =>
  import("@/components/AppLms/Catalogos/Temas/Listar_Temas/Listar_Temas");
const Actividades_Temas = () =>
  import("@/components/AppLms/Catalogos/Temas/actividades/actividades_temas");
const Grupos_Temas = () =>
  import("@/components/AppLms/Catalogos/Temas/Grupos_Temas/Grupos_Temas");
const Plantas_Temas = () =>
  import("@/components/AppLms/Catalogos/Temas/Plantas/Plantas_Temas");


//Catalogos/Bloques de cursos
const Bloques_Cursos = () =>
  import("@/components/AppLms/Catalogos/Bloques_Cursos/Bloques_Cursos");
const CrearBloque = () =>
  import("@/components/AppLms/Catalogos/Bloques_Cursos/crear_bloque/crear_bloque");

//Catalogos/Estructura de Puestos
const Estructura_Puestos = () =>
  import("@/components/AppLms/Catalogos/Estructura_Puestos/Estructura_Puestos");

//Plan de Capacitacion / Capacitacion Institucional / Consulta de Requerimientos
const Capacitacion_Institucional_Consulta_Requerimientos = () =>
  import(
    "@/components/AppLms/Plan_Capacitacion/Capacitacion_Institucional/Consulta_Requerimientos/Consulta_Requerimientos"
  );
const Capacitacion_Institucional_Alta_Requerimientos = () =>
  import(
    "@/components/AppLms/Plan_Capacitacion/Capacitacion_Institucional/Alta_Requerimientos/Alta_Requerimientos"
  );
const Capacitacion_Institucional_Avance_Tema = () =>
  import(
    "@/components/AppLms/Plan_Capacitacion/Capacitacion_Institucional/Avance_Tema/Avance_Tema"
  );

//Plan de Capacitacion / Plan de Formacion / Consulta de Requerimientos
const Plan_Formacion_Consulta_Requerimientos = () =>
  import(
    "@/components/AppLms/Plan_Capacitacion/Plan_Formacion/Consulta_Requerimientos/Consulta_Requerimientos"
  );
const Plan_Formacion_Alta_Requerimientos = () =>
  import(
    "@/components/AppLms/Plan_Capacitacion/Plan_Formacion/Alta_Requerimientos/Alta_Requerimientos"
  );
const Plan_Formacion_Baja_Requerimientos = () =>
  import(
    "@/components/AppLms/Plan_Capacitacion/Plan_Formacion/Baja_Requerimientos/Baja_Requerimientos"
  );
const Plan_Formacion_Avance_Consolidado = () =>
  import(
    "@/components/AppLms/Plan_Capacitacion/Plan_Formacion/Avance_Consolidado/Avance_Consolidado"
  );
const Plan_Formacion_Avance_Tema = () =>
  import(
    "@/components/AppLms/Plan_Capacitacion/Plan_Formacion/Avance_Tema/Avance_Tema"
  );

//Plan de Capacitacion / Capacitacion Especifica / Consulta de Requerimientos
const Capacitacion_Especifica_Consulta_Requerimientos = () =>
  import(
    "@/components/AppLms/Plan_Capacitacion/Capacitacion_Especifica/Consulta_Requerimientos/Consulta_Requerimientos"
  );
const Capacitacion_Especifica_Alta_Requerimientos = () =>
  import(
    "@/components/AppLms/Plan_Capacitacion/Capacitacion_Especifica/Alta_Requerimientos/Alta_Requerimientos"
  );

//Plan de Capacitacion / Historial de Capacitacion General
const Historial_Capacitacion_General = () =>
  import(
    "@/components/AppLms/Plan_Capacitacion/Historial_Capacitacion_General/Historial_Capacitacion_General"
  );

const Certificaciones_Externas = () =>
  import(
    "@/components/AppLms/Plan_Capacitacion/Certificaciones_Externas/Certificaciones_Externas"
  );

//Plan de Capacitacion / Consultar Plan de Capacitacion
const Consultar_Plan_Capacitacion = () =>
  import(
    "@/components/AppLms/Plan_Capacitacion/Consultar_Plan_Capacitacion/Consultar_Plan_Capacitacion"
  );

//Plan de Capacitacion / Reportes
const Reporte_Masivo = () =>
  import("@/components/AppLms/Reportes/Reporte_Masivo");
const Reporte_Masivo_Ecommerce = () =>
  import("@/components/AppLms/Reportes/reporte_masivo_ecommerce");
const Reporteador = () => import("@/components/AppLms/Reportes/Reporteador");

//Plan de Capacitacion / Simulador de Puesto
const Simulador_Puesto = () =>
  import(
    "@/components/AppLms/Plan_Capacitacion/Simulador_Puesto/Simulador_Puesto"
  );

//Plan de Capacitacion / Temas Empleados
const Temas_Empleados = () =>
  import(
    "@/components/AppLms/Plan_Capacitacion/Temas_Empleados/Temas_Empleados"
  );

//Plan de Capacitacion / Asignacion por bloques
const Asignacion_Bloques = () =>
  import(
    "@/components/AppLms/Plan_Capacitacion/Asignacion_Bloques/Asignacion_Bloques"
  );

//Plan de Capacitacion / Historial_Capacitacion_Bloques
const Historial_Capacitacion_Bloques = () =>
  import(
    "@/components/AppLms/Plan_Capacitacion/Historial_Capacitacion_Bloques/Historial_Capacitacion_Bloques"
  );

//Plan de Capacitacion / Ver de Kardex Capacitacion
const Ver_Kardex_Capacitacion = () =>
  import(
    "@/components/AppLms/Plan_Capacitacion/Ver_Kardex_Capacitacion/Ver_Kardex_Capacitacion"
  );

//Cursos
const Grid_Cursos = () => import("@/components/AppLms/Cursos/Grid_Cursos");
const Grid_Cursos_EPV = () => import("@/components/AppLms/Cursos/grid_cursos_epv");
const Calendar_Cursos = () =>
  import("@/components/AppLms/Cursos/Calendar_Cursos");
const Programar_Curso = () =>
  import("@/components/AppLms/Cursos/Programar_Curso");

//Configuracion
const Cargas_Masivas = () =>
  import("@/components/AppLms/Configuracion/Cargas_Masivas/Cargas_Masivas");

const Apis = () => import("@/components/AppLms/Apis/Apis");
const Creacion_Perfiles = () =>
  import("@/components/AppLms/Creacion_Perfiles/Creacion_Perfiles");

//Notificaciones
const Notificaciones = () =>
  import("@/components/AppLms/Notificaciones/Notificaciones");

//Indicadores
const Graficas = () =>
  import("@/components/AppLms/Indicadores/Graficas/Indicadores");
const GraficasEcommerce = () =>
  import("@/components/AppLms/Indicadores/Graficas/e-commerce/IndicadoresEcommerce");
const Avance_Grupos_Temas = () =>
  import(
    "@/components/AppLms/Indicadores/Avance_Grupos_Temas/Avance_Grupos_Temas"
  );

const Avance_Bloques_Temas = () =>
  import(
    "@/components/AppLms/Indicadores/Avance_Bloques_Temas/Avance_Bloques_Temas"
  );

const Avance_Audencia_Meta = () =>
  import(
    "@/components/AppLms/Indicadores/Avance_Audencia_Meta/Avance_Audencia_Meta"
  );
const Resultado_Encuestas_Salida = () =>
  import(
    "@/components/AppLms/Indicadores/resultado_encuestas_salida/resultado_encuestas_salida"
  );

//Confirmar asistenica
const Confirmar_Asistencia = () =>
  import("@/components/AppLms/Confirmar_Asistencia/Confirmar_Asistencia");
const Descargar_ICS = () =>
  import("@/components/AppLms/Descargar_ICS/Descargar_ICS");

//Panel de Cursos
const Panel_Cursos = () =>
  import("@/components/AppLms/Panel_Cursos/Panel_Cursos");

//Teams
const Teams = () => import("@/components/AppLms/Teams/Teams");

//Reportes
const Capacitaciones_Proximas_Vencer = () =>
  import("@/components/AppLms/Reportes/Capacitaciones_Proximas_Vencer");

//Configuracion
const Configuracion = () =>
  import("@/components/AppLms/Configuracion/Configuracion");

const TemaView = () =>
  import(
    "../components/AppLms/Plan_Capacitacion/Consultar_Plan_Capacitacion/VerTema/TemaView.vue"
  );
const Encuestas_Cursos = () =>
  import("../components/AppLms/Catalogos/EncuestasCursos/EncuestasCurso.vue");

const FAQ = () => import("@/components/AppLogin/Login/FAQ");
const Ayuda = () => import("@/components/AppLogin/Login/Ayuda");

//E-COMMERCE
const InicioECommerce = () =>
  import("@/components/AppLms/e-commerce/ecommerce-inicio");
const ShoppingCart = () =>
  import("@/components/AppLms/e-commerce/shopping_cart/shopping_cart");
const DetalleBloque = () =>
  import("@/components/AppLms/e-commerce/detalle-bloque/detalle-bloque");
const Checkout = () =>
  import("@/components/AppLms/e-commerce/payment/checkout");
const PaymentSuccess = () =>
  import("@/components/AppLms/e-commerce/payment/payment_success");
const MiFacturacion = () =>
  import("@/components/AppLms/e-commerce/mi_facturacion/mi_facturacion");
const Facturacion = () =>
  import("@/components/AppLms/e-commerce/facturacion/facturacion");
const HistorialCompras = () =>
  import("@/components/AppLms/e-commerce/compras_admin/compras_admin");

Vue.use(Router);

export default new Router({
  routes: [
    { path: "", name: "Login", component: Login },
    { path: "/", name: "Login2", component: Login },
    { path: "/login", name: "Login3", component: Login },
    {
      path: "/restorePassword/:jwt",
      name: "RestorePassword",
      component: restorePass
    },
    {
      path: "/FAQ",
      name: "FAQ",
      component: FAQ
    },
    {
      path: "/AccionPrueba",
      name: "AccionPrueba",
      component: AccionPrueba
    },
    {
      path: "/menu",
      name: "Menu",
      component: Main_Menu,
      meta: { requiresAuth: true },
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          meta: { title: "Dashboard" },
          component: Dashboard
        },
        {
          path: "ayuda",
          name: "Ayuda",
          meta: { title: "Ayuda" },
          component: Ayuda
        },
        //Catalogos/Empleados
        {
          path: "empleados",
          name: "Empleados",
          meta: { title: "Catalogos" },
          component: Empleados
        },
        //Encuestas de cursos
        {
          path: "encuestas_cursos",
          name: "Encuestas de cursos",
          meta: { title: "Catalogos" },
          component: Encuestas_Cursos
        },
        //Catalogos/Asignacion
        {
          path: "cambiar_perfil_usuario",
          name: "Cambiar_Perfil_Usuario",
          meta: { title: "Catalogos" },
          component: Cambiar_Perfil_Usuario
        },
        {
          path: "analista_simulado",
          name: "Analista_Simulado",
          meta: { title: "Catalogos" },
          component: Analista_Simulado
        },

        //Catalogos/Control de Poblacion
        {
          path: "control_poblacion",
          name: "Control_Poblacion",
          meta: { title: "Catalogos" },
          component: Control_Poblacion
        },

        //Catalogos/Datos STPS
        {
          path: "representantes_DC3",
          name: "Representantes_DC3",
          meta: { title: "Catalogos" },
          component: Representantes_DC3
        },
        {
          path: "areas_tematicas",
          name: "areas_tematicas",
          meta: { title: "Catalogos" },
          component: areas_tematicas
        },
        {
          path: "plantilla_DC4",
          name: "Plantilla_DC4",
          meta: { title: "Catalogos" },
          component: Plantilla_DC4
        },
        {
          path: "establecimientos_STPS",
          name: "Establecimientos_STPS",
          meta: { title: "Catalogos" },
          component: Establecimientos_STPS
        },

        //Catalogos/Recursos de Capacitacion
        {
          path: "recursos_capacitacion",
          name: "Recursos_Capacitacion",
          meta: { title: "Catalogos" },
          component: Recursos_Capacitacion
        },

        //Catalogos/Temas
        {
          path: "crear_tema",
          name: "Crear_Tema",
          meta: { title: "Catalogos" },
          component: Crear_Tema
        },
        {
          path: "ver_tema/:cve_tema",
          name: "Ver_Tema",
          meta: { title: "Catalogos" },
          component: Ver_Tema
        },
        {
          path: "temas/preguntas/:cve_tema",
          name: "Preguntas_Tema",
          meta: { title: "Catalogos" },
          component: Preguntas_Tema
        },
        {
          path: "listar_temas",
          name: "Listar_Temas",
          meta: { title: "Catalogos" },
          component: Listar_Temas
        },
        {
          path: "temas/actividades_temas",
          name: "actividades_temas",
          meta: { title: "Catalogos" },
          component: Actividades_Temas
        },
        {
          path: "grupos_temas",
          name: "Grupos_Temas",
          meta: { title: "Catalogos" },
          component: Grupos_Temas
        },
        {
          path: "plantas_temas",
          name: "Plantas_Temas",
          meta: { title: "Catalogos" },
          component: Plantas_Temas
        },

        //Catalogos/Estructura de Puestos
        {
          path: "estructura_puestos",
          name: "Estructura_Puestos",
          meta: { title: "Catalogos" },
          component: Estructura_Puestos
        },

        //Catalogos/Bloques_Cursos
        {
          path: "bloques_cursos",
          name: "Bloques_cursos",
          meta: { title: "Bloques de Cursos" },
          component: Bloques_Cursos
        },
        {
          path: "crear_bloque",
          name: "crear_bloque",
          component: CrearBloque,
        },

        //Plan de Capacitacion/Capacitacion Institucional
        {
          meta: { title: "Plan_Capacitacion" },
          path: "capacitacion_institucional_consulta_requerimientos",
          name: "Capacitacion_Institucional_Consulta_Requerimientos",
          component: Capacitacion_Institucional_Consulta_Requerimientos
        },
        {
          meta: { title: "Plan_Capacitacion" },
          path: "capacitacion_institucional_alta_requerimientos",
          name: "Capacitacion_Institucional_Alta_Requerimientos",
          component: Capacitacion_Institucional_Alta_Requerimientos
        },
        {
          meta: { title: "Plan_Capacitacion" },
          path: "capacitacion_institucional_avance_tema",
          name: "Capacitacion_Institucional_Avance_Tema",
          component: Capacitacion_Institucional_Avance_Tema
        },

        //Plan de Capacitacion/Plan de Formacion
        {
          meta: { title: "Plan_Capacitacion" },
          path: "plan_formacion_consulta_requerimientos",
          name: "Plan_Formacion_Consulta_Requerimientos",
          component: Plan_Formacion_Consulta_Requerimientos
        },
        {
          meta: { title: "Plan_Capacitacion" },
          path: "plan_formacion_alta_requerimientos",
          name: "Plan_Formacion_Alta_Requerimientos",
          component: Plan_Formacion_Alta_Requerimientos
        },
        {
          meta: { title: "Plan_Capacitacion" },
          path: "plan_formacion_baja_requerimientos",
          name: "Plan_Formacion_Baja_Requerimientos",
          component: Plan_Formacion_Baja_Requerimientos
        },
        {
          meta: { title: "Plan_Capacitacion" },
          path: "plan_formacion_avance_consolidado",
          name: "Plan_Formacion_Avance_Consolidado",
          component: Plan_Formacion_Avance_Consolidado
        },
        {
          meta: { title: "Plan_Capacitacion" },
          path: "plan_formacion_avance_tema",
          name: "Plan_Formacion_Avance_Tema",
          component: Plan_Formacion_Avance_Tema
        },

        //Plan de Capacitacion/Capacitacion Especifica
        {
          meta: { title: "Plan_Capacitacion" },
          path: "capacitacion_especifica_consulta_requerimientos",
          name: "Capacitacion_Especifica_Consulta_Requerimientos",
          component: Capacitacion_Especifica_Consulta_Requerimientos
        },
        {
          meta: { title: "Plan_Capacitacion" },
          path: "capacitacion_especifica_alta_requerimientos",
          name: "Capacitacion_Especifica_Alta_Requerimientos",
          component: Capacitacion_Especifica_Alta_Requerimientos
        },

        //Plan de Capacitacion/Historial Capacitacion General
        {
          meta: { title: "Plan_Capacitacion" },
          path: "historial_capacitacion_general",
          name: "Historial_Capacitacion_General",
          component: Historial_Capacitacion_General
        },

        //Plan de Capacitacion/Consultar Plan de Capacitacion
        {
          meta: { title: "Plan_Capacitacion" },
          path: "consultar_plan_capacitacion",
          name: "Consultar_Plan_Capacitacion",
          component: Consultar_Plan_Capacitacion,
          props: true
        },
        {
          meta: { title: "Plan_Capacitacion" },
          path: "certificaciones_externas",
          name: "certificaciones_externas",
          component: Certificaciones_Externas,
          props: true
        },
        {
          path: "tema_view",
          name: "TemaView",
          meta: { title: "Vista de tema" },
          component: TemaView,
          props: true
        },

        //Plan de Capacitacion/Reportes
        {
          meta: { title: "Reporte_Masivo" },
          path: "reporte_masivo",
          name: "Reporte_Masivo",
          component: Reporte_Masivo
        },
        {
          meta: { title: "Reporte_Masivo_Ecommerce" },
          path: "reporte_masivo_ecommerce",
          name: "Reporte_Masivo_Ecommerce",
          component: Reporte_Masivo_Ecommerce
        },
        {
          meta: { title: "Reporteador" },
          path: "reporteador",
          name: "Reporteador",
          component: Reporteador
        },

        //Plan de Capacitacion/Simulador de Puesto
        {
          meta: { title: "Plan_Capacitacion" },
          path: "simulador_puesto",
          name: "Simulador_Puesto",
          component: Simulador_Puesto
        },

        //Plan de Capacitacion/Temas Empleados
        {
          meta: { title: "Plan_Capacitacion" },
          path: "temas_empleados",
          name: "Temas_Empleados",
          component: Temas_Empleados
        },

        //Plan de Capacitacion/Asignacion por bloques
        {
          meta: { title: "Plan_Capacitacion" },
          path: "asignacion_bloques",
          name: "Asignacion_Bloques",
          component: Asignacion_Bloques
        },

        //Plan de Capacitacion/Historial de capacitacion por bloques
        {
          meta: { title: "Historial_Capacitacion_Bloques" },
          path: "historial_capacitacion_bloques",
          name: "Historial_Capacitacion_Bloques",
          component: Historial_Capacitacion_Bloques
        },

        //Plan de Capacitacion/Ver Kardex de Capacitacion
        {
          meta: { title: "Plan_Capacitacion" },
          path: "ver_kardex_capacitacion",
          name: "Ver_Kardex_Capacitacion",
          component: Ver_Kardex_Capacitacion
        },

        //Cursos
        {
          meta: { title: "Cursos EPV" },
          path: "grid_cursos_epv",
          name: "grid_cursos_epv",
          component: Grid_Cursos_EPV
        },
        {
          meta: { title: "Cursos" },
          path: "grid_cursos",
          name: "Grid_Cursos",
          component: Grid_Cursos
        },
        {
          meta: { title: "Cursos" },
          path: "calendar_cursos",
          name: "Calendar_Cursos",
          component: Calendar_Cursos
        },
        {
          meta: { title: "Cursos" },
          path: "programar_curso",
          name: "Programar_Curso",
          component: Programar_Curso,
          props: true
        },

        //Configuracion/Cargas Masivas
        {
          meta: { title: "Cargas_Masivas" },
          path: "cargas_masivas",
          name: "Cargas_Masivas",
          component: Cargas_Masivas
        },

        {
          meta: { title: "Apis" },
          path: "apis",
          name: "Apis",
          component: Apis
        },
        {
          meta: { title: "Creacion_Perfiles" },
          path: "Creacion_perfiles",
          name: "creacion_Perfiles",
          component: Creacion_Perfiles
        },

        //Notificiaciones
        {
          meta: { title: "Notificaciones" },
          path: "notificaciones",
          name: "Notificaciones",
          component: Notificaciones
        },

        //Indicadores
        {
          meta: { title: "Graficas" },
          path: "graficas",
          name: "Graficas",
          component: Graficas
        },
        {
          meta: { title: "Graficas Ecommerce" },
          path: "graficas_ecommerce",
          name: "GraficasEcommerce",
          component: GraficasEcommerce
        },
        {
          meta: { title: "Avance_Grupos_Temas" },
          path: "avance_grupos_temas",
          name: "Avance_Grupos_Temas",
          component: Avance_Grupos_Temas
        },
        {
          meta: { title: "Avance_Bloques_Temas" },
          path: "avance_bloques_temas",
          name: "Avance_Bloques_Temas",
          component: Avance_Bloques_Temas
        },
        {
          meta: { title: "Avance_Audencia_Meta" },
          path: "avance_audencia_meta",
          name: "Avance_Audencia_Meta",
          component: Avance_Audencia_Meta
        },
        {
          meta: { title: "Resultado_Encuestas_Salida" },
          path: "resultado_encuestas_salida",
          name: "Resultado_Encuestas_Salida",
          component: Resultado_Encuestas_Salida
        },

        {
          path: "confirmar_asistencia/curso/:idempleados_calificaciones",
          name: "Confirmar_Asistencia",
          component: Confirmar_Asistencia
        },
        {
          path: "descargar_ics/curso/:cve_curso",
          name: "Descargar_ICS",
          component: Descargar_ICS
        },

        { path: "panel_cursos", name: "Panel_Cursos", component: Panel_Cursos },

        { path: "teams", name: "Teams", component: Teams },

        {
          path: "configuracion",
          name: "Configuracion",
          component: Configuracion
        },

        {
          path: "capacitaciones_proximas_vencer",
          name: "Capacitaciones_Proximas_Vencer",
          component: Capacitaciones_Proximas_Vencer
        },

        // ECOMMERCE
        {
          path: "ecommerce_inicio",
          name: "Ecommerce_Inicio",
          component: InicioECommerce,
        },
        {
          path: "shopping_cart",
          name: "Shopping_Cart",
          component: ShoppingCart,
        },
        {
          path: "detalle_bloque",
          name: "Detalle_Bloque",
          component: DetalleBloque,
        },
        {
          path: "/payment/checkout",
          name: "checkout",
          component: Checkout,
        },
        {
          path: "/mi_facturacion",
          name: "mi_facturacion",
          component: MiFacturacion,
        },
        {
          path: "facturacion",
          name: "facturacion",
          component: Facturacion,
        },
        {
          path: "/historial_compras",
          name: "historial_compras",
          component: HistorialCompras,
        },
      ],
    },
    {
      path: "/payment/success",
      name: "paymentSuccess",
      component: PaymentSuccess,
    },
  ]
});



// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/src/router/index.js